var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcQuoteSuperBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 22.834L51 20.334L48.5 22.834L46 20.334L43.5 22.834L41 20.334L38.5 22.834L36 20.334L33.5 22.834L31 20.334L28.5 22.834L26 20.334V53.6673L28.5 51.1673L31 53.6673L33.5 51.1673L36 53.6673L38.5 51.1673L41 53.6673L43.5 51.1673L46 53.6673L48.5 51.1673L51 53.6673L53.5 51.1673L56 53.6673V20.334L53.5 22.834ZM52.6667 48.8173H29.3333V25.184H52.6667V48.8173ZM31 42.0007H51V45.334H31V42.0007ZM31 35.334H51V38.6673H31V35.334ZM31 28.6673H51V32.0007H31V28.6673Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuoteSuperBigCircle);
export default __webpack_public_path__ + "static/media/ic_quote_super_big_circle.56818ded4e260f00f86b556606e1421d.svg";
export { ForwardRef as ReactComponent };